import { createImagesApi } from '~/entities/image/api/images-api'

export const eventImagesApi = createImagesApi('events')
